import React from 'react'
import Directory from '../components/directory/Directory'
import "../styles/homepage.css"
const Homepage = () => {
    return (
        <div className='homepage'>
            <Directory/>
        </div>
    )
}

export default Homepage
